// ----
// JS for OUP Sticky Footer Ad logic
// ----
var App = App || {};

const mobileThreshold = 767; // Value based on css rules

App.StickyFooterAd = (function () {
    return {
        Init: init
    };

    function init() {
        //If we see the Cookie Banner, reposition the Sticky Ad and add a DOM Listener for reposition the Ad after the Cookie Banner is gone
        const $cookieBanner = $('#cookie-consent-banner');
        if ($cookieBanner && $cookieBanner.is(':visible')) {
            repositionFooterAd();
            addCookieBannerListener();
        }

        setAdContainerHeight();
        setAdvertisementTextHeight();

        //Scroll Handler for the sticky ad
        $(window).on('scroll', throttle(stickyAdScrollLogic, 20));

        //Setup the logic of the Close Footer Ad button
        const $closeFooterAdButton = $('.js-close-footer-ad');
        $closeFooterAdButton.on('click', function () {
            $(this).parents('.js-sticky-footer-ad').hide();
            //Unbind the method for the scroll window event
            $(window).off('scroll', stickyAdScrollLogic);
        });
    }

    function repositionFooterAd() {
        const $cookieBanner = $('#cookie-consent-banner');
        const $footerAd = $('.js-sticky-footer-ad .js-adBlock-parent-wrap');
        if ($cookieBanner && $cookieBanner.length === 0) {
            // Cookie banner is removed, reposition footer ad
            $footerAd.css('bottom', 0);
        } else {
            // Cookie banner is present, reset footer ad position
            $footerAd.css('bottom', $cookieBanner.outerHeight(true));
        }
    }

    function addCookieBannerListener() {
        // Use MutationObserver for monitoring the Cookie Consent Banner
        const observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                if (mutation.removedNodes && mutation.removedNodes.length > 0) {
                    // Check if the Cookie Banner was removed
                    if ($(mutation.removedNodes).is('#cookie-consent-banner')) {
                        repositionFooterAd();
                    }
                }

                if (mutation.addedNodes && mutation.addedNodes.length > 0) {
                    // Check if the Cookie Banner was addded back
                    if ($(mutation.addedNodes).is('#cookie-consent-banner')) {
                        repositionFooterAd();
                    }
                }
            });
        });

        // Also reposition the Sticky Footer Ad if resizing the viewport changes the height of the cookie banner
        $(window).on('resize', debounce(repositionFooterAd, 100));

        // Start observing changes in the DOM
        observer.observe(document.body, { childList: true });
    }

    function stickyAdScrollLogic() {
        const $window = $(window);
        const $footerAdContainer = $('.js-sticky-footer-ad');
        const $footerAdInnerContainer = $footerAdContainer.find('.js-adBlock-parent-wrap');
        const $footerAdContent = $footerAdContainer.find('.js-adblock');
        const $closeFooterAdButton = $footerAdContainer.find('.js-close-footer-ad');
        const $advertisementText = $footerAdContainer.find('.js-adblock-advertisement-text');

        const footerAdOffset = $footerAdContainer.offset().top + $footerAdContainer.height();
        const scrolledPosition = $window.scrollTop() + $window.height();
        const footerAdPosition = $footerAdInnerContainer.css('position');

        if (scrolledPosition >= footerAdOffset) {
            if (footerAdPosition === 'fixed') {
                $footerAdInnerContainer.css({
                    position: 'relative',
                    bottom: ''
                });
                $footerAdContent.removeClass('undocked').addClass('docked');
                $closeFooterAdButton.hide();
                $advertisementText.height('').removeClass('sticky-advertisement-text');
                const viewportWidth = $(window).width();
                if (viewportWidth > mobileThreshold) {
                    $advertisementText.height($footerAdContent.height());
                }
            }
        } else {
            if (footerAdPosition === 'relative') {
                $footerAdInnerContainer.css({
                    position: 'fixed',
                    bottom: '0'
                });
                $footerAdContent.removeClass('docked').addClass('undocked');
                setAdvertisementTextHeight();
                $closeFooterAdButton.show();

                //If we see the Cookie Banner, reposition the Sticky Ad
                const $cookieBanner = $('#cookie-consent-banner');
                if ($cookieBanner && $cookieBanner.is(':visible')) {
                    repositionFooterAd();
                }
            }
        }
    }

    function setAdContainerHeight() {
        const $footerAd = $('.js-sticky-footer-ad .js-adblock');
        const $footerAdWrapper = $('.js-sticky-footer-ad');
        let adHeight = $footerAd.height() + 10; //5px for top and bottom padding when docked
        const viewportWidth = $(window).width();
        if (viewportWidth <= mobileThreshold) {
            adHeight = $('.js-sticky-footer-ad .js-adblock-advertisement-text').outerHeight(true) + adHeight;
        }
        $footerAdWrapper.height(adHeight);
    }

    function setAdvertisementTextHeight() {
        //Check if we're on mobile view
        const viewportWidth = $(window).width();
        if (viewportWidth > mobileThreshold) {
            const $footerAd = $('.js-sticky-footer-ad .js-adblock');
            const $advertisementText = $('.js-sticky-footer-ad .js-adblock-advertisement-text');
            //Set advertisement-text height
            $advertisementText.height($footerAd.height());
            //Add the css class that removes padding and adds borders to the advertisement-text
            $advertisementText.addClass('sticky-advertisement-text');
        }
    }
})();